export enum BoardPurchaseFlowRuleDirectionEnum {
  Start = 'Start',
  End = 'End',
}
